export default function QuotesTable({ items }) {
    if (items.length === 0) {
        return <p className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground" data-testid="quotes-empty">No quote requests yet.</p>;
    }
    return (
        <div className="overflow-x-auto rounded-2xl border border-border bg-surface" data-testid="quotes-table">
            <table className="w-full text-left text-sm">
                <thead className="border-b border-border font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
                    <tr>
                        {["Received", "Name", "Contact", "Agency", "Rate", "Emailed"].map((h) => (
                            <th key={h} className="px-4 py-3 font-medium">{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-border">
                    {items.map((q) => (
                        <tr key={q.id} data-testid={`quote-row-${q.id}`}>
                            <td className="whitespace-nowrap px-4 py-3 font-mono text-xs text-muted-foreground">{q.created_at.slice(0, 16).replace("T", " ")}</td>
                            <td className="px-4 py-3 font-semibold">{q.name}</td>
                            <td className="px-4 py-3 text-muted-foreground">
                                <a href={`mailto:${q.email}`} className="hover:text-primary">{q.email}</a>
                                <br />
                                <span className="font-mono text-xs">{q.phone}</span>
                            </td>
                            <td className="px-4 py-3">{q.agency}</td>
                            <td className="whitespace-nowrap px-4 py-3 font-mono">${Number(q.rate).toLocaleString()} / {q.rate_basis}</td>
                            <td className="px-4 py-3">
                                <span className={`rounded-full px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest ${q.notified_at ? "bg-primary/10 text-primary" : "bg-surface-2 text-muted-foreground"}`}>
                                    {q.notified_at ? "Sent" : "Not sent"}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
